import { Component, ViewEncapsulation, HostBinding, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { NgIf, NgClass } from '@angular/common';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

import { LoadingSpinnerComponent } from '../utils/loading-spinner.component';
import { UserService } from '../../services/user.service';
import { simpleTransitions } from '../../shared/animations/simple-transitions';


@Component({
	selector: 'copo-change-user-email',
	templateUrl: './change-user-email.component.html',
	animations: simpleTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	styleUrls: ['./change-user-email.component.css'],
	standalone: true,
	imports: [
		ReactiveFormsModule,
		MatIconModule,
		TranslateModule,
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyButtonModule,
		NgIf,
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyFormFieldModule,
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyInputModule,
		NgClass,
		// eslint-disable-next-line deprecation/deprecation
		MatLegacyTableModule,
		LoadingSpinnerComponent,
	],
})
export class ChangeUserEmailComponent implements OnInit {
	@HostBinding('class.mat-typography') matTypography = true;
	@HostBinding('class.full-height') fullHeight = true;
	sessionToken: string | undefined;
	portalUrl?: string;
	isSpinLoading = true;
	isInValidSessionToken = false;

	constructor(
		private readonly route: ActivatedRoute,
		private readonly userService: UserService,
		// eslint-disable-next-line deprecation/deprecation
		public dialog: MatDialog,
	) {}

	ngOnInit() {
		const params = <Record<string, string | undefined>> this.route.snapshot.queryParams;
		this.sessionToken = params['session_token'];
		if (!this.sessionToken) {
			return;
		}
		this.userService.updateEmail(this.sessionToken)
			.then(results => {
				this.portalUrl = results;
				this.isSpinLoading = false;
			}).catch(error => {
				this.isSpinLoading = false;
				console.error('error while updating Email', error);
				this.isInValidSessionToken = true;
			});
	}

	notFoundUrl() {
		return new URL('**', location.origin);
	}

	redirectPortal() {
		window.open(this.portalUrl, '_blank');
	}
}
